import NavbarNotAuth from '../userNotAuth/components/navbarNotAuth'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import DivBottom from '../userNotAuth/components/divBottom'
import { RotatingLines } from "react-loader-spinner"

function User() {
    const navigate = useNavigate()
    const userId = localStorage.getItem('id')

    const [user, setUser] = useState(null)
    const [artista, setArtista] = useState(null)
    const [formData, setFormData] = useState({ email: '' })
    const [msg, setMsg] = useState({ email: null, axiosError: null })
    const modificaEmail = useRef()
    const inputEmail = useRef()
    const emailSuccess = useRef()
    const disiscrivitiButton = useRef()

    const grid = {
        display: 'grid',
        gridTemplateColumns: '5rem 0.8fr',
        gap: '5px'
    }
    async function getUser() {
        try {
            const res = await axios.get(`/getUser/${userId}`)
            setUser(res.data.results)
            setArtista(res.data.artista)
        } catch (err) { console.log(err) }
    }
    function edit() {
        modificaEmail.current.style.display = "block"
    }
    function handleChange(e) {
        const { name, value } = e.target
        setFormData({ ...formData, [name]: value })
        setMsg({ email: false, axiosError: null })
    }
    function handleLogin(e) {
        e.preventDefault()
        const validRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (!validRegex.test(formData.email) || formData.email === '') {
            setMsg({ email: 'Email non valida' }); return
        }
        axios.post('/sendEmailxmodificaEmail', formData).then(res => {
            if (res.data.message === 'Success') {
                localStorage.setItem('previousPage', '/user')
                navigate('/reimpostaEmail', {
                    replace: true,
                    state: { rndCode: res.data.rndCode, emailNuova: formData.email }
                })
            } else if (res.data === 'failed') {
                setMsg({ ...msg, email: 'Email già esistente' })
            }
        })
    }
    useEffect(() => { getUser() }, [])
    useEffect(() => {
        if (user !== null && user.statoRegistrazione === 'unscribe') {
            disiscrivitiButton.current.disabled = true
            document.getElementById('btnModifica').disabled = true
        }
    }, [user])
    return (<>
        <NavbarNotAuth />
        <br /><br />
        <div className='container mt-5' style={{ marginBottom: '48px' }}>
            <h2 className='m-4'>I miei dati di registrazione</h2>
            <br />
            {!user &&
                <h5 style={{ height: '10em' }}>Caricamento in corso...<RotatingLines strokeColor='black' strokeWidth='5' animationDuration='5' width='26' /></h5>
            }
            {user &&
                <div><br />

                    <div style={grid}>
                        <div><b>Stato </b></div><div>{
                            user.statoRegistrazione === 'true' ? `Iscritto` :
                                user.statoRegistrazione === 'unscribe' ?
                                    <span style={{ color: 'red' }} >Disiscritto</span> : null
                        }</div>
                    </div><hr />

                    <div style={grid}>
                        <div><b>Nome</b> </div> <div>{user.nome}</div>
                    </div>
                    {artista &&
                        <div style={grid}>
                            <div><b>Genere</b> </div> <div>{artista.genere}</div>
                        </div>
                    }
                    <hr />
                    <div style={grid} className='mt-3'>
                        <div><b>Email </b></div>
                        <div>{user.email}</div>
                    </div>
                    <button style={{ fontSize: 'small', marginLeft: '5rem', opacity: '.8' }} id="btnModifica"
                        onClick={edit}>
                        modifica
                    </button>
                    <div style={{
                        border: '1px solid grey',
                        padding: '5px',
                        display: 'none',
                        marginBottom: '2rem'
                    }}
                        className='mt-3 fs-5' ref={modificaEmail}>
                        <span style={{ float: 'right', cursor: 'pointer' }} onClick={() => {
                            modificaEmail.current.style.display = "none"
                            setFormData({ ...formData, email: '' })
                            setMsg({ ...msg, email: '' })
                            inputEmail.current.value = ''
                        }}>X
                        </span>
                        <form onSubmit={handleLogin}>
                            <label htmlFor="email" style={{ fontSize: 'large' }}>Nuova Email:</label>
                            <input ref={inputEmail}
                                className="form-control"
                                name="email" required
                                onChange={handleChange}
                                type="text"
                            />
                            {msg.email && <div style={{ color: 'red', fontSize: 'large' }}>
                                {msg.email}
                            </div>
                            }
                            <button className='btn btn-primary mt-3' type="submit">Procedi</button>
                        </form>
                    </div>
                    <p style={{
                        color: 'navy',
                        fontSize: 'large',
                        border: '1px solid gray',
                        padding: '10px',
                        display: 'none'
                    }} className='mt-3' ref={emailSuccess}>
                        <b>
                            Abbiamo inviato un email a {formData.email}<br />
                            Apri il messaggio per confermare la nuova email.
                        </b>
                    </p>
                    <hr />
                    <div style={{ display: 'grid', gridTemplateColumns: '5rem 0.8fr', gap: '5px' }}>
                        <div className='mt-2'><b>Num Id </b></div><div className='mt-2'>{user.id}</div>
                        <div><b>Iscritto il </b></div><div>{user.data}</div>
                    </div>
                    {user.img &&
                        <div style={{ display: 'grid', gridTemplateColumns: '5rem 0.8fr', gap: '5px', marginTop: '1em' }}>
                            <div><b>Immagine</b></div>
                            <div>
                                <img src={`https://leuro-bucket.s3.amazonaws.com/${user.img}`} style={{ maxWidth: '110px', maxHeight: '80px' }} /></div>
                        </div>
                    }
                    <hr />
                    <div className='mt-2'><b>Logout</b>
                        <button style={{ width: '3rem', marginLeft: '2rem', borderRadius: '8px' }}
                            onClick={() => { navigate('/logout', { replace: true }) }}>⇏</button>
                    </div>
                </div>
            }
        </div>
        <DivBottom />
    </>)
}
export default User